var A = { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
let G = 0;
function nt(t, c) {
  const d = `atom${++G}`, a = {
    toString() {
      return (A ? "production" : void 0) !== "production" && this.debugLabel ? d + ":" + this.debugLabel : d;
    }
  };
  return typeof t == "function" ? a.read = t : (a.init = t, a.read = $, a.write = q), c && (a.write = c), a;
}
function $(t) {
  return t(this);
}
function q(t, c, d) {
  return c(
    this,
    typeof d == "function" ? d(t(this)) : d
  );
}
const z = (t, c) => t.unstable_is ? t.unstable_is(c) : c === t, V = (t) => "init" in t, U = (t) => !!t.write, k = Symbol(
  (A ? "production" : void 0) !== "production" ? "CONTINUE_PROMISE" : ""
), F = "pending", H = "fulfilled", K = "rejected", Q = (t) => typeof t == "object" && t !== null && k in t, O = /* @__PURE__ */ new WeakMap(), X = (t, c, d) => {
  if (!O.has(t)) {
    let a;
    const w = new Promise((E, R) => {
      let y = t;
      const M = (h) => (b) => {
        y === h && (w.status = H, w.value = b, E(b), d());
      }, m = (h) => (b) => {
        y === h && (w.status = K, w.reason = b, R(b), d());
      };
      t.then(M(t), m(t)), a = (h, b) => {
        h && (O.set(h, w), y = h, h.then(M(h), m(h)), c(), c = b);
      };
    });
    w.status = F, w[k] = a, O.set(t, w);
  }
  return O.get(t);
}, Y = (t) => typeof (t == null ? void 0 : t.then) == "function", J = (t) => "v" in t || "e" in t, I = (t) => {
  if ("e" in t)
    throw t.e;
  if ((A ? "production" : void 0) !== "production" && !("v" in t))
    throw new Error("[Bug] atom state is not initialized");
  return t.v;
}, C = (t) => {
  const c = t.v;
  return Q(c) && c.status === F ? c : null;
}, W = (t, c, d) => {
  d.p.has(t) || (d.p.add(t), c.then(
    () => {
      d.p.delete(t);
    },
    () => {
      d.p.delete(t);
    }
  ));
}, D = () => [/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map(), /* @__PURE__ */ new Set()], j = (t, c, d) => {
  t[0].has(c) || t[0].set(c, /* @__PURE__ */ new Set()), t[1].set(c, d);
}, Z = (t, c, d) => {
  const a = t[0].get(c);
  a && a.add(d);
}, x = (t, c) => t[0].get(c), B = (t, c) => {
  t[2].add(c);
}, g = (t) => {
  for (; t[1].size || t[2].size; ) {
    t[0].clear();
    const c = new Set(t[1].values());
    t[1].clear();
    const d = new Set(t[2]);
    t[2].clear(), c.forEach((a) => {
      var w;
      return (w = a.m) == null ? void 0 : w.l.forEach((E) => E());
    }), d.forEach((a) => a());
  }
}, tt = () => {
  const t = /* @__PURE__ */ new WeakMap();
  let c;
  (A ? "production" : void 0) !== "production" && (c = /* @__PURE__ */ new Set());
  const d = (s) => {
    let e = t.get(s);
    return e || (e = { d: /* @__PURE__ */ new Map(), p: /* @__PURE__ */ new Set(), n: 0 }, t.set(s, e)), e;
  }, a = (s, e, o, n = () => {
  }, r = () => {
  }) => {
    const l = "v" in e, u = e.v, p = C(e);
    if (Y(o))
      if (p)
        p !== o && (p[k](o, n), ++e.n);
      else {
        const f = X(
          o,
          n,
          r
        );
        if (f.status === F)
          for (const i of e.d.keys()) {
            const v = d(i);
            W(
              s,
              f,
              v
            );
          }
        e.v = f, delete e.e;
      }
    else
      p && p[k](
        Promise.resolve(o),
        n
      ), e.v = o, delete e.e;
    (!l || !Object.is(u, e.v)) && ++e.n;
  }, w = (s, e, o, n) => {
    var r;
    if ((A ? "production" : void 0) !== "production" && o === e)
      throw new Error("[Bug] atom cannot depend on itself");
    const l = d(e);
    l.d.set(o, n.n);
    const u = C(l);
    u && W(e, u, n), (r = n.m) == null || r.t.add(e), s && Z(s, o, e);
  }, E = (s, e, o) => {
    const n = d(e);
    if (!(o != null && o(e)) && J(n) && (n.m || Array.from(n.d).every(
      ([i, v]) => (
        // Recursively, read the atom state of the dependency, and
        // check if the atom epoch number is unchanged
        E(s, i, o).n === v
      )
    )))
      return n;
    n.d.clear();
    let r = !0;
    const l = (i) => {
      if (z(e, i)) {
        const _ = d(i);
        if (!J(_))
          if (V(i))
            a(i, _, i.init);
          else
            throw new Error("no atom init");
        return I(_);
      }
      const v = E(s, i, o);
      if (r)
        w(s, e, i, v);
      else {
        const _ = D();
        w(_, e, i, v), h(_, e, n), g(_);
      }
      return I(v);
    };
    let u, p;
    const f = {
      get signal() {
        return u || (u = new AbortController()), u.signal;
      },
      get setSelf() {
        return (A ? "production" : void 0) !== "production" && !U(e) && console.warn("setSelf function cannot be used with read-only atom"), !p && U(e) && (p = (...i) => {
          if ((A ? "production" : void 0) !== "production" && r && console.warn("setSelf function cannot be called in sync"), !r)
            return m(e, ...i);
        }), p;
      }
    };
    try {
      const i = e.read(l, f);
      return a(
        e,
        n,
        i,
        () => u == null ? void 0 : u.abort(),
        () => {
          if (n.m) {
            const v = D();
            h(v, e, n), g(v);
          }
        }
      ), n;
    } catch (i) {
      return delete n.v, n.e = i, ++n.n, n;
    } finally {
      r = !1;
    }
  }, R = (s) => I(E(void 0, s)), y = (s, e) => {
    const o = (f) => {
      var i, v;
      const _ = d(f), S = new Set((i = _.m) == null ? void 0 : i.t);
      for (const P of _.p)
        S.add(P);
      return (v = x(s, f)) == null || v.forEach((P) => {
        S.add(P);
      }), S;
    }, n = [], r = /* @__PURE__ */ new Set(), l = (f) => {
      if (!r.has(f)) {
        r.add(f);
        for (const i of o(f))
          f !== i && l(i);
        n.push(f);
      }
    };
    l(e);
    const u = /* @__PURE__ */ new Set([e]), p = (f) => r.has(f);
    for (let f = n.length - 1; f >= 0; --f) {
      const i = n[f], v = d(i), _ = v.n;
      let S = !1;
      for (const P of v.d.keys())
        if (P !== i && u.has(P)) {
          S = !0;
          break;
        }
      S && (E(s, i, p), h(s, i, v), _ !== v.n && (j(s, i, v), u.add(i))), r.delete(i);
    }
  }, M = (s, e, ...o) => {
    const n = (u) => I(E(s, u)), r = (u, ...p) => {
      let f;
      if (z(e, u)) {
        if (!V(u))
          throw new Error("atom not writable");
        const i = d(u), v = "v" in i, _ = i.v, S = p[0];
        a(u, i, S), h(s, u, i), (!v || !Object.is(_, i.v)) && (j(s, u, i), y(s, u));
      } else
        f = M(s, u, ...p);
      return g(s), f;
    };
    return e.write(n, r, ...o);
  }, m = (s, ...e) => {
    const o = D(), n = M(o, s, ...e);
    return g(o), n;
  }, h = (s, e, o) => {
    if (o.m && !C(o)) {
      for (const n of o.d.keys())
        o.m.d.has(n) || (b(s, n).t.add(e), o.m.d.add(n));
      for (const n of o.m.d || [])
        if (!o.d.has(n)) {
          o.m.d.delete(n);
          const r = L(s, n);
          r == null || r.t.delete(e);
        }
    }
  }, b = (s, e) => {
    const o = d(e);
    if (!o.m) {
      E(s, e);
      for (const n of o.d.keys())
        b(s, n).t.add(e);
      if (o.m = {
        l: /* @__PURE__ */ new Set(),
        d: new Set(o.d.keys()),
        t: /* @__PURE__ */ new Set()
      }, (A ? "production" : void 0) !== "production" && c.add(e), U(e) && e.onMount) {
        const n = o.m, { onMount: r } = e;
        B(s, () => {
          const l = r(
            (...u) => M(s, e, ...u)
          );
          l && (n.u = l);
        });
      }
    }
    return o.m;
  }, L = (s, e) => {
    const o = d(e);
    if (o.m && !o.m.l.size && !Array.from(o.m.t).some((n) => {
      var r;
      return (r = d(n).m) == null ? void 0 : r.d.has(e);
    })) {
      const n = o.m.u;
      n && B(s, n), delete o.m, (A ? "production" : void 0) !== "production" && c.delete(e);
      for (const l of o.d.keys()) {
        const u = L(s, l);
        u == null || u.t.delete(e);
      }
      const r = C(o);
      r && r[k](void 0, () => {
      });
      return;
    }
    return o.m;
  }, N = {
    get: R,
    set: m,
    sub: (s, e) => {
      const o = D(), n = b(o, s);
      g(o);
      const r = n.l;
      return r.add(e), () => {
        r.delete(e);
        const l = D();
        L(l, s), g(l);
      };
    }
  };
  return (A ? "production" : void 0) !== "production" && Object.assign(N, {
    // store dev methods (these are tentative and subject to change without notice)
    dev4_get_internal_weak_map: () => t,
    dev4_get_mounted_atoms: () => c,
    dev4_restore_atoms: (e) => {
      const o = D();
      for (const [n, r] of e)
        if (V(n)) {
          const l = d(n), u = "v" in l, p = l.v;
          a(n, l, r), h(o, n, l), (!u || !Object.is(p, l.v)) && (j(o, n, l), y(o, n));
        }
      g(o);
    }
  }), N;
};
let T;
const ot = () => (T || (T = tt(), (A ? "production" : void 0) !== "production" && (globalThis.__JOTAI_DEFAULT_STORE__ || (globalThis.__JOTAI_DEFAULT_STORE__ = T), globalThis.__JOTAI_DEFAULT_STORE__ !== T && console.warn(
  "Detected multiple Jotai instances. It may cause unexpected behavior with the default store. https://github.com/pmndrs/jotai/discussions/2044"
))), T);
export {
  nt as a,
  ot as g
};
//# sourceMappingURL=vanilla-CSAfDK5R.js.map
